/* eslint-disable no-undef */
export const DealerHoursBlk = {
  props: [],
  data() {
    return {
      selectHoursBlk: 'sales-tab',
    }
  },
  methods: {
    clicHoursBlk(tab){
      this.selectHoursBlk = tab
  },
  },
}
